export class QuestionConfigs{
    public static SelectionCharLimit: number = 145;
}